import { UserService } from '@duck/api-definitions'
import { useAuth } from '@/hooks/useAuth'
import { useTar } from '@/modules'
import { Button } from '@duck/ui'

interface InviteGateWrongAccountProps {
  details: UserService.InvitationDetails
  loggedInEmail: string
}

export const InviteGateWrongAccount = ({ details, loggedInEmail }: InviteGateWrongAccountProps) => {
  const { t } = useTar()
  const { signOut } = useAuth()

  if (!details.email) return null

  return (
    <div className="w-full max-w-md space-y-4 text-center">
      <h1 className="text-2xl font-semibold">{t('invite.wrongAccount.title')}</h1>
      <p className="text-sm text-muted-foreground">
        {t('invite.wrongAccount.body', { inviteEmail: details.email, userEmail: loggedInEmail })}
      </p>
      <div className="flex gap-2 justify-center">
        <Button variant="outline" onClick={() => window.history.back()}>
          {t('invite.wrongAccount.stay')}
        </Button>
        <Button onClick={() => signOut?.()}>{t('invite.wrongAccount.logout')}</Button>
      </div>
    </div>
  )
}
